import { mutationTree } from "typed-vuex";
import { UserRes } from "@wl/types/lib/responses/user/user.res";
import state, { UserState } from "./state";

/**
 * User module mutations.
 */
const mutations = mutationTree(state, {
    /**
     * Sets the users access token.
     *
     * @param {UserState} state User state
     * @param {(string | null)} token Access token to set
     */
    setToken(state: UserState, token: string | null): void {
        state.token = token;
    },

    /**
     * Sets the fetched user.
     *
     * @param {UserState} state User state
     * @param {(UserRes | undefined)} user User to set
     */
    setUser(state: UserState, user: UserRes | undefined): void {
        if (user) state.current = user;
    },

    /**
     * Clears the user module state.
     *
     * @param {UserState} state
     */
    clear(state: UserState): void {
        state.current = null;
        state.token = null;
    },
});

export default mutations;
